interface GridIconProps {
	className?: string;
}

export function GridIcon({ className }: GridIconProps) {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 15 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			role="img"
			aria-label="Grid"
		>
			<path
				d="M1.875 9.27051H4.6875C5.2628 9.27051 5.72949 9.7372 5.72949 10.3125V13.125C5.72949 13.7003 5.2628 14.167 4.6875 14.167H1.875C1.2997 14.167 0.833008 13.7003 0.833008 13.125V10.3125C0.833008 9.7372 1.2997 9.27051 1.875 9.27051ZM10.3125 9.27051H13.125C13.7003 9.27051 14.167 9.7372 14.167 10.3125V13.125C14.167 13.7003 13.7003 14.167 13.125 14.167H10.3125C9.7372 14.167 9.27051 13.7003 9.27051 13.125V10.3125C9.27051 9.7372 9.7372 9.27051 10.3125 9.27051ZM1.875 0.833008H4.6875C5.2628 0.833009 5.72949 1.2997 5.72949 1.875V4.6875C5.72949 5.2628 5.2628 5.72949 4.6875 5.72949H1.875C1.2997 5.72949 0.833008 5.2628 0.833008 4.6875V1.875C0.833008 1.2997 1.2997 0.833008 1.875 0.833008ZM10.3125 0.833008H13.125C13.7003 0.833009 14.167 1.2997 14.167 1.875V4.6875C14.167 5.2628 13.7003 5.72949 13.125 5.72949H10.3125C9.7372 5.72949 9.27051 5.2628 9.27051 4.6875V1.875C9.27051 1.2997 9.7372 0.833008 10.3125 0.833008Z"
				stroke="currentColor"
				strokeWidth="1.66667"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
